module.exports = __webpack_public_path__ + "static/media/zacke.c317709d.svg";